import { render, staticRenderFns } from "./ChangePortfolioBackgroundModal.vue?vue&type=template&id=83abaeb4&scoped=true&"
import script from "./ChangePortfolioBackgroundModal.vue?vue&type=script&setup=true&lang=ts&"
export * from "./ChangePortfolioBackgroundModal.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./ChangePortfolioBackgroundModal.vue?vue&type=style&index=0&id=83abaeb4&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83abaeb4",
  null
  
)

export default component.exports